import {Box, Text} from '@primer/react'

type DescriptionProps = {
  children: React.ReactNode | string
}

const Description = ({children, ...restProps}: React.HTMLAttributes<HTMLElement> & DescriptionProps) => {
  if (typeof children === 'string') {
    return (
      <Text
        as="p"
        sx={{font: 'var(--text-body-shorthand-small)', lineHeight: 1.5, color: 'fg.muted', margin: 0}}
        {...restProps}
      >
        {children}
      </Text>
    )
  }

  return (
    <Box as="span" sx={{font: 'var(--text-body-shorthand-small)', color: 'fg.muted'}} {...restProps}>
      {children}
    </Box>
  )
}
Description.displayName = 'ControlGroup.Description'

export default Description
